import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import CustomerSupportEmail from '../Account/CustomerSupportEmail';
import CustomerSupportPhone from '../Account/CustomerSupportPhone';

export default function ContactUs() {

  return (
    <Container>
      <Row className="justify-content-center">
        <Col>
          <h4>Want to Get In Touch With Us?</h4>
          <p>Please contact us using the information below. We have agents standing by ready to assist with your insurance needs.</p>
          <h4>Sales Support</h4>
          <h5>Phone</h5>
          <p>Please call us at {CustomerSupportPhone()}</p>
          <h5>Email</h5>
          <p>Email us at <a href={`mailto:${CustomerSupportEmail()}`}>{CustomerSupportEmail()}</a></p>
          <h5>Hours of Operation</h5>
          <p>Monday through Friday 8:00 AM ET to 6:00 PM ET</p>
          <h5>Company/Location</h5>
          <p>Covr<br />1 American Row<br />Hartford, CT 06102</p>
        </Col>
      </Row>
    </Container>
  )
}